
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/credittent/privacy-policy",
      function () {
        return require("private-next-pages/credittent/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/credittent/privacy-policy"])
      });
    }
  